import { markAnswer } from "seneca-common/features/module/module-types/wordfill/logic/answers";
import { Answer } from "seneca-common/features/module/module-types/wordfill/types";

export { markAnswer };

export const generateInitialUserAnswer = (): Answer => {
  return {
    words: {}
  };
};
